import { useState } from "react";
import { useGuests } from "../../Providers/Guests";
import { useHabUnits } from "../../Providers/HabUnit";

import {
  ContainerCheckIn,
  CurrentGuestsContainer,
  SelectGuests,
} from "./style";
import { IGuest, IHU } from "../../Interfaces";
import Button from "../Button";

interface IFormCheckInProps {
  HU: IHU;
  closeModal: () => void;
}

const FormCheckIn = ({ HU, closeModal }: IFormCheckInProps) => {
  const { checkIn } = useHabUnits();
  const { guests } = useGuests();

  const [userInput, setUserInput] = useState<string>("");
  const [date] = useState<Date>(new Date());
  const [selectedGuests, setSelectedGuests] = useState<IGuest[]>([]);
  const [selectedOption, setSelectedOption] = useState();

  const onSubmit = () => {

    const newCheckIn = { date: date, guests: selectedGuests };
    if (newCheckIn !== undefined) {
      if (selectedGuests.length > 0) {
        checkIn(HU, selectedGuests);
        closeModal();
      } 
    }
  };

  const handleChange = (e: any) => {
    setSelectedOption(e.target.value);
  };

  const handleAdd = () => {
    if (selectedOption !== undefined) {
      const newGuest = guests.find((el) => el.cpf === selectedOption);
      if (newGuest !== undefined) {
        setSelectedGuests([...selectedGuests, newGuest]);
      }
    }
    setUserInput("");
  };

  return (
    <ContainerCheckIn>
      <input
        type="text"
        value={userInput}
        onChange={(e) => setUserInput(e.target.value)}
        placeholder="Pesquisar hóspede por CPF"
        className="search"
      />
      <SelectGuests className="selectGuests">
        <label htmlFor={"listNames"}>Hospedes</label>
        <select onChange={handleChange} value={selectedOption} id="listNames">
          {guests
            .filter((el) => el.cpf.includes(userInput))
            ?.map((el) => (
              <option key={el.id} value={el.cpf}>
                {el.name}
              </option>
            ))}
        </select>
      </SelectGuests>
      <Button className="addButton" onClick={handleAdd}>
        Adicionar
      </Button>
      <CurrentGuestsContainer>
        <h2>Hóspedes</h2>
        {selectedGuests?.map((el, index) => (
          <p key={index}>{el.name}</p>
        ))}
      </CurrentGuestsContainer>
      <Button className="default" onClick={onSubmit}>
        Check In
      </Button>
    </ContainerCheckIn>
  );
};

export default FormCheckIn;
